module.exports = "/_next/static/images/img_2-mobile-3e3ab21b8339f3d25439b8bb9eece9a1.png";